export const SAVE_ALL_ROLES = 'SAVE_ALL_ROLES'
export const SAVE_ROLE = 'SAVE_ROLE'
